import { findIndex } from 'lodash';

import { StoreApplicant } from '@funnels/types';

export default function getIndexFromCustomerId(data: StoreApplicant[], id?: string) {
  if (!id) {
    return -1;
  }

  return findIndex(data, (obj: StoreApplicant) => obj.customerId === id);
}
